import { useLazyQuery, useQuery } from '@apollo/client';

import ME_QUERY from 'graphql/user/queries/me.graphql';

import { MeQuery } from 'graphql/types';

export const useCurrentUser = () => useQuery<MeQuery>(ME_QUERY);

export const useLazyCurrentUser = () => useLazyQuery<MeQuery>(ME_QUERY);
